import { NgModule} from '@angular/core';
import { NgbModal } from './modal';
export { NgbModal } from './modal';
import { NgbModalModule, NgbModalOptions, NgbActiveModal, NgbModalRef, ModalDismissReasons } from './modal.module';
export { NgbModalModule, NgbModalOptions, NgbActiveModal, NgbModalRef, ModalDismissReasons } from './modal.module';

@NgModule({
  imports: [NgbModalModule],
  exports: [NgbModalModule]
})
export class NgbModule {}
